module.exports = __webpack_public_path__ + "img/logo_3.a1e57ba5.png";